module.exports = __webpack_public_path__ + "static/media/1.c04e5c16.svg";